import {Component} from 'react';
import {connect} from 'react-redux';
import injectSheet from 'react-jss';

import {getAllStipsForApplicantSelector} from '-/selectors';
import NavigationService from '-/services/NavigationService';
import StipsHeader from '-/components/general/StipsHeader';
import StipDocStatus from '-/components/fields/StipDocStatus';
import StepButtons from '-/components/general/StepButtons';
import Form from '-/components/fields/Form';
import Button from '-/components/general/Button';

const styles = () => ({
    root: {
        textAlign: 'center'
    }
});

class StipsStatus extends Component {
    renderCloseButton() {
        const btn = <Button tag="a" onClick={() => NavigationService.startOver()}>Close</Button>;

        return <StepButtons buttons={btn} />;
    }

    renderStatuses() {
        const {
            stips,
            applicantType
        } = this.props;
        return (
            <div className="stips-status-list">
                {stips.map((stip, idx) => {
                    return stip.docs.map((doc, j) => {
                        if (doc.status === 'NOTREQUIRED') {
                            return null;
                        }

                        const key = `${stip.docType}_${applicantType}_${idx}_${j}`;

                        return (
                            <StipDocStatus key={key} stip={stip} doc={doc} />
                        );
                    });
                })}
            </div>
        );
    }

    render() {
        const {classes = {}} = this.props;

        return (
            <div className="stips-status">
                <div className={classes.root}>
                    <Form standalone={true}>
                        <StipsHeader />
                        {this.renderStatuses()}
                    </Form>
                </div>
                {this.renderCloseButton()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const stips = getAllStipsForApplicantSelector(state);
    const {applicantType} = state.stips;

    return {
        stips,
        applicantType
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(StipsStatus));
